var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { animate, useMotionValue, } from 'framer-motion';
import { CarouselItem } from './CarouselItem';
import { Children, useCallback, useEffect, useRef, } from 'react';
import { styled } from '@mui/system';
var transition = {
    type: 'spring',
    bounce: 0,
};
export var CarouselTrack = function (_a) {
    var children = _a.children, _b = _a.autoPlay, autoPlay = _b === void 0 ? false : _b, _c = _a.interval, interval = _c === void 0 ? 2000 : _c, _d = _a.loop, loop = _d === void 0 ? true : _d, _e = _a.itemsPerPage, itemsPerPage = _e === void 0 ? 1 : _e, index = _a.index, handlePrev = _a.handlePrev, handleNext = _a.handleNext;
    var x = useMotionValue(0);
    var containerRef = useRef(null);
    var calculateNewX = useCallback(function () { var _a; return -index * ((((_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.clientWidth) || 0) / itemsPerPage); }, [index, containerRef, itemsPerPage]);
    var handleDragEnd = function (e, dragProps) {
        var _a;
        var clientWidth = ((_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.clientWidth) || 0;
        var offset = dragProps.offset;
        var threshold = clientWidth / 4;
        if (offset.x > threshold * 2) {
            return handlePrev(2);
        }
        if (offset.x < -threshold * 2) {
            return handleNext(2);
        }
        if (offset.x > threshold) {
            return handlePrev();
        }
        if (offset.x < -threshold) {
            return handleNext();
        }
        return animate(x, calculateNewX(), transition);
    };
    var childrenArray = Children.toArray(children);
    useEffect(function () {
        var controls = animate(x, calculateNewX(), transition);
        return controls.stop;
    }, [index, calculateNewX, x]);
    useEffect(function () {
        if (!autoPlay)
            return;
        var timer = setInterval(function () { return handleNext(); }, interval);
        return function () { return clearInterval(timer); };
    }, [handleNext, interval, autoPlay]);
    return (_jsx(Wrapper, __assign({ ref: containerRef }, { children: childrenArray.map(function (child, index) { return (_jsx(CarouselItem, __assign({ onDragEnd: handleDragEnd, x: x, index: index, itemsPerPage: itemsPerPage }, { children: child }), index)); }) })));
};
var Wrapper = styled('div')({
    position: 'relative',
    width: '100%',
    height: '100%',
    overflowX: 'hidden',
    display: 'flex',
});
